// extracted by mini-css-extract-plugin
module.exports = {"Item":"ContentBlueForm__Item_3dKU5"};